export default {
  label: {
    firstName: 'Prénom',
    lastName: 'Nom',
    email: 'Courriel',
    password: 'Mot de passe',
    phone: 'Téléphone',
    currentPassword: 'Nouveau mot de passe',
    record: 'Enregistrer',
    oldPassword: 'Ancien mot de passe',
    newPassword:'nouveau mot de passe'
  },
  account: {
    title: 'Mon compte',
    salesHistoricTitle: 'Historique des commandes',
    ordersPlacedIn: 'Commandes passées en',
    emptyOrderTableText: 'Aucune commandes',
    salesHistoricDescription: 'Ici, tu as accès à l\'historique de tous les achats que tu as fait chez Boires.',
    consultSalesHistoric: 'Consulter mon historique',
    profileTitle: 'Profil client',
    profileDescription: 'Ici, tu peux modifier tes informations personnelles.Tiens-les à jour pour de t\'assurer de recevoir tes commandes au bon endroit.',
    consultMyProfile: 'Consulter mon profil',
    subscriptionTitle: 'Abonnements',
    subscriptionDescription: 'Ici, tu peux modifier tes préférences et t\'abonner à nos infolettres.',
    consultsubscription: 'Consulter mes abonnements',
    logout: 'Fermer la session',
    personnalInfosTitle: 'Information personnelle',
    editBtn: 'Éditer',
    search: 'Chercher',
    password: 'Mot de passe',
    salesHistory: {
      orderHeader: 'Commande',
      salesOrderNumberHeader: 'Numéro',
      salesOrderTotalHeader: 'Total',
      invoice: 'Facture',
      price: 'Prix',
      agencyFee: 'Frais d\'agence : ',
      saqValue: 'Valeur SAQ : ',
      qty: '{x} caisse (x{n}) | {x} caisses (x{n}) ',
      noData: 'Aucun historique de commande'
    },
    shippingAndBillingAddresses: 'Adresse de livraison et facturation',
    branchPickup: 'Ramassage en succursale',
    chercher: 'Chercher'
  },
  login: {
    title: 'Connexion',
    label: {
      forgotPassword: 'Mot de passe oublié',
      login: 'Se connecter',
    },
    account: 'COMPTE',
    rememberMe: 'Se souvenir de moi'
  },
  registration: {
    intro: 'Crée ton compte pour rentrer tes infomations juste une fois! Tu pourras aussi avoir accès à ton historique de commande et de livraison.',
    title: 'Inscription',
    label: {
      consent: 'J\'aimerais recevoir les nouvelles de Boires.ca',
      register: 'S\'inscrire',
    },
    confirmationSuccess: 'Inscription effecutée',
    confirmationText: 'Merci pour ton inscription. <br>Tu recevras un courriel de confirmation sous peu avec des instructions pour activer ton compte!',
  },
  suggestions: 'Nos Suggestions',
  forgotPassword: {
    title: 'MODIFICATION DU MOT DE PASSE',
    placeHolder: 'Nouveau mot de passe',
    button: 'Modifier',
    text: '2021 Boires Inc. tous droits réservés - BOIRES est une marque de commerce déposée de Boires Inc.',
  },
  forgotPasswordModal: {
    title1: 'MOT DE PASSE OUBLIÉ',
    title2: 'Mot de passe temporaire envoyé',
    placeHolder: 'Courriel',
    button: 'Réinitialiser le mot de passe',
    cancel: 'Annuler',
    text: 'Nous t`enverrons un courriel pour réinitialiser ton mot de passe.',
    success: 'Mot de passe temporaire envoyé',
    successBtn: 'Fermer',
    successTextPart1: 'Un courriel contenant un mot de passe temporaire a été envoyé à',
    successTextPart2: 'Veuillez vérifier votre boîte de réception et utiliser le mot de passe temporaire pour accéder à votre compte. N\'oubliez pas de changer votre mot de passe après vous être connecté(e) pour des raisons de sécurité. Merci !',
  },
  deliveryAddress: {
    aptSuite: 'Apt / suite',
    rue: 'Rue',
    civicNumber: 'Numéro civique',
    province: 'Province',
    codePostal: 'Code postal',
    ville: 'Ville',
    copyAddress: 'Utiliser la même adresse pour la livraison',
    deliveryAddress: 'Adresse de livraison',
    billingAddress: 'Adresse de facturation',
    formRequiredMsg: {
      rue: 'Votre rue est obligatoire',
      ville: 'Votre ville est obligatoire',
      province: 'Votre province est obligatoire',
      codePostal: 'Votre Code Postal est obligatoire',
      rue2: 'Votre rue est obligatoire',
      firstName: 'Votre prénom est obligatoire',
      lastName: 'Votre nom est obligatoire',
      email: 'Votre courriel est obligatoire',
      phone: 'Votre téléphone est obligatoire',
    },
    formPatternMsg:{
      email: 'Le courriel n\'est pas valide, veuillez saisir un courriel valide.',
      phone: ' Le numéro de téléphone n\'est pas valide, veuillez saisir un numéro de téléphone valide.',
    },
  },
  branchPickup: {
    title: 'RECHERCHER UNE SUCCURSALE',
    subTitle: 'Sélectionne une ville pour voir les succursales disponibles.',
    cancel: 'Annuler',
    submit: 'Sélectionner'
  },
  resetPassword: {
    title: 'Créer un nouveau mot de passe',
    confirpwd: 'Confirmer le mot de passe'
  }
};
